/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Regulamin pobytu') {
            document.title = 'Regulamin pobytu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>REGULAMIN POBYTU W POKOJACH HOTEL HUBERTUS RZESZÓW</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Pokoje wynajmowane są na doby, doba zaczyna się o godz. 14:00 i kończy o godz. 12:00 ostatniego dnia pobytu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel Hubertus Rzeszów świadczy usługi zgodnie ze swoim standardem. Aktualne opisy poszczególnych pokoi oraz ich wyposażenia znajdują się na stronie internetowej obiektu: <a href="https://hubertus.rzeszow.pl" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://hubertus.rzeszow.pl
                        </Button>
                    </a></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel posiada recepcję czynną całodobowo i recepcjonista jest zawsze do dyspozycji gości.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel zapewnia odpowiednie warunki do wygodnego wypoczynku Gościa, bezpieczeństwo oraz poufność pobytu, miłą i profesjonalną obsługę, a na wyraźne życzenie Gościa – sprzątanie pokoju oraz wymianę ręczników w trakcie pobytu dłuższego niż 1 doba.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel uwzględni prośbę o przedłużenie pobytu w miarę możliwości, tj. w przypadku dostępności wolnego pokoju.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Gość nie może przekazać opłaconego pokoju osobom trzecim, nawet w przypadku kiedy nie wykorzystał całego opłaconego pobytu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Dzieci śpią na dostępnych łóżkach. Istnieje możliwość dostawienia łóżeczka dla niemowlęcia bezpłatnie. Liczba łóżeczek jest ograniczona.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zwierzęta nie są akceptowane.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Na terenie hotelu oraz w pokojach obowiązuje całkowity zakaz palenia tytoniu. W przypadku naruszenia zakazu Gość zostanie obciążony kosztami neutralizacji zapachu dymu tytoniowego oraz ewentualnymi kosztami związanymi z uruchomieniem systemu przeciwpożarowego i interwencją odpowiednich służb.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Cisza nocna obowiązuje od godz. 22.00 do godz. 6.00 rano.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Osoby niezameldowane w obiekcie mogą przebywać na jego terenie od godziny 6.00 do 20.00.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Goście obiektu ponoszą odpowiedzialność za wszelkie szkody wyrządzone w pokojach. Szkoda oznacza zarówno zniszczenie lub uszkodzenie elementów wyposażenia pokoju jak ich utratę.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku powstania szkody podczas pobytu Gość zobowiązany jest do pokrycia kosztów jej naprawy. Za szkody wyrządzone przez dzieci odpowiadają rodzice lub opiekunowie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Gość powinien niezwłocznie zawiadomić obsługę o wystąpieniu szkody lub jej stwierdzeniu po zameldowaniu i wejściu do pokoju. W przeciwnym wypadku może zostać zobowiązany do pokrycia kosztów zniszczeń.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Ze względów bezpieczeństwa przeciwpożarowego zabronione jest używanie urządzeń elektrycznych niebędących na wyposażeniu pokoju (np. żelazek, grzałek, czajników elektrycznych).</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel nie ponosi odpowiedzialności za uszkodzenie pojazdu należącego do Gościa ani za rzeczy wartościowe pozostawione w pokojach. Do dyspozycji Gości jest parking niestrzeżony, monitorowany całodobowo.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel nie ponosi odpowiedzialności za utratę lub uszkodzenie rzeczy wniesionych przez Gościa w zakresie określonym przepisami Kodeksu cywilnego (art. 846–849).</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel nie przyjmuje w depozyt pieniędzy, papierów wartościowych ani innych przedmiotów o szczególnej wartości. W przypadku ich utraty lub zniszczenia hotel nie ponosi odpowiedzialności.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Goście zobowiązują się wykorzystywać pokoje wyłącznie do celów mieszkalnych. Zabrania się organizowania imprez.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku gdy Gość w sposób znaczący narusza spokój lub dobra innych osób bądź nie przestrzega powszechnie obowiązujących norm współżycia społecznego, hotel zastrzega sobie prawo do wypowiedzenia pobytu bez obowiązku zwrotu środków za niewykorzystany okres.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Hotel zastrzega sobie prawo odmowy wynajmu pokoju Gościom, którzy podczas poprzedniego pobytu rażąco naruszyli regulamin.</Typography></li>
                    
                </ol>
                
                <hr style={{ border: "0", borderBottom: "1px solid rgb(224, 224, 224)" }} />
                <br /><Typography variant='body2' gutterBottom>Rezerwacja pokoju oznacza zapoznanie się i akceptację powyższego regulaminu.</Typography>
                <br /><Typography variant='body2' gutterBottom style={{fontSize: '16px'}}><b>Życzymy miłego wypoczynku i zapraszamy ponownie!</b></Typography>
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    bottomLabelFont: {
        fontSize: '16',
    }
});

export default withStyles(styles)(HotelTest);
